import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-c34cb194"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "homebox clearfix"
};
const _hoisted_2 = {
  key: 3,
  class: "owin-height"
};
const _hoisted_3 = {
  class: "notice-top"
};
const _hoisted_4 = {
  class: "text"
};
const _hoisted_5 = {
  class: "notice-wrapper"
};
const _hoisted_6 = {
  class: "notice-list-wrapper"
};
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  class: "left-content"
};
const _hoisted_9 = {
  class: "left_top"
};
const _hoisted_10 = {
  class: "date-day"
};

const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "date-separator"
}, "/", -1));

const _hoisted_12 = {
  class: "date-m-y"
};
const _hoisted_13 = {
  class: "date-month"
};
const _hoisted_14 = {
  class: "date-year"
};

const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "lins"
}, null, -1));

const _hoisted_16 = {
  class: "notice-title-box"
};
const _hoisted_17 = ["title", "innerHTML"];
const _hoisted_18 = ["title", "innerHTML"];

const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "notice-text"
}, [/*#__PURE__*/_createTextVNode(" 查看详情 "), /*#__PURE__*/_createElementVNode("img", {
  src: "https://image.zhihuishu.com/zhs/b2cm/base1/202507/02169fa145ee4c2fba9ba7d399030e03.png",
  alt: ""
})], -1));

const _hoisted_20 = ["src"];
const _hoisted_21 = {
  key: 1,
  class: "empty-box"
};
const _hoisted_22 = {
  key: 4
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Head = _resolveComponent("Head");

  const _component_BannerTemplate = _resolveComponent("BannerTemplate");

  const _component_ClassroomTemplate = _resolveComponent("ClassroomTemplate");

  const _component_Quality = _resolveComponent("Quality");

  const _component_el_input = _resolveComponent("el-input");

  const _component_el_tab_pane = _resolveComponent("el-tab-pane");

  const _component_el_tabs = _resolveComponent("el-tabs");

  const _component_Empty = _resolveComponent("Empty");

  const _component_el_pagination = _resolveComponent("el-pagination");

  const _component_el_config_provider = _resolveComponent("el-config-provider");

  const _component_Footer = _resolveComponent("Footer");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_Head, {
    menuCode: _ctx.menuCode,
    onGetUserInfo: $options.getUserInfo,
    menuInfo: $data.menuInfo,
    "onUpdate:menuInfo": _cache[0] || (_cache[0] = $event => $data.menuInfo = $event),
    onUserRole: $options.getZhsRole,
    isLogin: $data.isLogin,
    "onUpdate:isLogin": _cache[1] || (_cache[1] = $event => $data.isLogin = $event)
  }, null, 8, ["menuCode", "onGetUserInfo", "menuInfo", "onUserRole", "isLogin"]), $data.menuInfo.layout === 0 ? (_openBlock(), _createBlock(_component_BannerTemplate, {
    key: 0,
    classList: $data.newsTypeList,
    menuId: $data.menuId,
    data: $data.newsList,
    menuInfo: $data.menuInfo,
    onGoDetails: $options.showNewsDetail
  }, null, 8, ["classList", "menuId", "data", "menuInfo", "onGoDetails"])) : $data.menuInfo.layout === 1 ? (_openBlock(), _createBlock(_component_ClassroomTemplate, {
    key: 1,
    data: $data.newsList,
    menuName: $data.menuInfo.nav_name,
    searchVal: $data.newsName,
    "onUpdate:searchVal": _cache[2] || (_cache[2] = $event => $data.newsName = $event),
    loading: $data.loading,
    onSearch: _cache[3] || (_cache[3] = $event => $options.handleSearch()),
    onClear: $options.handleClear,
    onGoDetails: $options.showNewsDetail,
    onSortChange: $options.handleSortChange
  }, null, 8, ["data", "menuName", "searchVal", "loading", "onClear", "onGoDetails", "onSortChange"])) : $data.menuInfo.layout === 2 ? (_openBlock(), _createBlock(_component_Quality, {
    key: 2,
    data: $data.newsList,
    classList: $data.newsTypeList,
    menuName: $data.menuInfo.nav_name,
    onGoDetails: $options.showNewsDetail
  }, null, 8, ["data", "classList", "menuName", "onGoDetails"])) : $data.showNone ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString($data.menuInfo.nav_name) + " ", 1), _createVNode(_component_el_input, {
    modelValue: $data.newsName,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.newsName = $event),
    class: "search-input",
    clearable: "",
    onClear: $options.handleClear,
    onKeyup: _cache[6] || (_cache[6] = _withKeys($event => $options.handleSearch(), ["enter"])),
    placeholder: `搜索${$data.menuInfo.nav_name}`
  }, {
    prefix: _withCtx(() => [_createElementVNode("i", {
      class: "iconfont icon-sousuo search-icon",
      onClick: _cache[4] || (_cache[4] = $event => $options.handleSearch())
    })]),
    _: 1
  }, 8, ["modelValue", "onClear", "placeholder"])]), _createElementVNode("div", _hoisted_5, [_createVNode(_component_el_tabs, {
    modelValue: $data.activeTab,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.activeTab = $event),
    onTabClick: $options.handleTabClick,
    class: "custom-tabs"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_tab_pane, {
      label: "全部",
      name: "home"
    }), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsTypeList, item => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: item.id,
        label: item.name,
        name: item.id.toString()
      }, null, 8, ["label", "name"]);
    }), 128))]),
    _: 1
  }, 8, ["modelValue", "onTabClick"]), _createElementVNode("div", _hoisted_6, [$data.newsList.length ? (_openBlock(), _createElementBlock("div", {
    key: 0,
    style: _normalizeStyle({
      'margin-bottom': $options.needPagination ? '0' : '64px'
    }),
    class: "notice-list"
  }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.newsList, item => {
    return _openBlock(), _createElementBlock("div", {
      class: "second-style",
      key: item.id,
      onClick: $event => $options.showNewsDetail(item)
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("span", _hoisted_10, _toDisplayString($options.formatDay(item.publish_time)), 1), _hoisted_11, _createElementVNode("div", _hoisted_12, [_createElementVNode("span", _hoisted_13, _toDisplayString($options.formatMonth(item.publish_time)) + "月", 1), _createElementVNode("span", _hoisted_14, _toDisplayString($options.formatYear(item.publish_time)), 1)])]), _hoisted_15, _createElementVNode("div", {
      class: _normalizeClass(["notice-content-box", {
        'no-content': !item.cover_url
      }])
    }, [_createElementVNode("div", _hoisted_16, [_createElementVNode("div", {
      class: "notice-title text-overflow",
      title: item.news_name.length > 40 ? item.news_name : '',
      "data-html": "",
      innerHTML: $options.kewordFilter(item.news_name)
    }, null, 8, _hoisted_17)]), _createElementVNode("div", {
      class: "notice-content text-overflow-three",
      title: _ctx.$utils.getContentText(item.context),
      "data-html": "",
      innerHTML: _ctx.$utils.getContentText(item.context)
    }, null, 8, _hoisted_18), _hoisted_19], 2), item.cover_url ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["notice_imgs", {
        'no-image': !item.cover_url
      }])
    }, [item.cover_url ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: item.cover_url,
      class: "notice-img",
      alt: ""
    }, null, 8, _hoisted_20)) : _createCommentVNode("", true)], 2)) : _createCommentVNode("", true)])], 8, _hoisted_7);
  }), 128))], 4)) : _createCommentVNode("", true), !$data.newsList.length ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createVNode(_component_Empty, {
    text: `暂无${$data.menuInfo.nav_name}`
  }, null, 8, ["text"])])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), $options.needPagination && $data.menuInfo.layout === 1 ? (_openBlock(), _createElementBlock("div", _hoisted_22, [_createVNode(_component_el_config_provider, {
    locale: $data.locale
  }, {
    default: _withCtx(() => [_createVNode(_component_el_pagination, {
      class: "news-pagination",
      background: "",
      layout: "total, sizes, prev, pager, next, jumper",
      onSizeChange: $options.handleSizeChange,
      onCurrentChange: $options.pageIndexChange,
      "current-page": $data.pageInfo.pageIndex,
      total: $data.pageInfo.rows,
      "page-sizes": [12, 24, 40, 80, 120],
      "page-size": $data.pageInfo.pageLimit,
      "hide-on-single-page": ""
    }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "total", "page-size"])]),
    _: 1
  }, 8, ["locale"])])) : _createCommentVNode("", true), _createVNode(_component_Footer)]);
}